<template>
  <v-tabs color="primary">
    <v-tab>General</v-tab>
    <v-tab-item :key="`offer-aggregated-LP-${this.item.data.id }-general`">
      <v-row class="text-center aggregatedOfferGrid">
        <v-data-table
            :headers="offersAggregatedHeader"
            :items="this.getOffersAggregated"
            :items-per-page="10"
            class="elevation-1 items-size-45"
        >
          <template v-slot:item.name="{item}">
                  <span class="td_title">
                     <a class="entity-link">{{ item.name }}</a>
                  </span>
          </template>
        </v-data-table>
      </v-row>
    </v-tab-item>
  </v-tabs>

</template>

<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    item: {
      type: Object
    }
  },
  async mounted() {
    await this.$store.dispatch('offer/saveOfferAggregatedStore', this.item.data.id)
  },
  methods: {},
  computed: {
    ...mapGetters('offer', ['getOffersAggregated', 'getOffer']),
  },
  name: "offerAggregatedLPCard",
  data() {
    return {
      offersAggregatedHeader: [
        {
          text: 'ID',
          align: 'start',
          sortable: false,
          value: 'id',
        },
        {text: 'Name', value: 'name'},
        {text: 'advertiserName', value: 'advertiserName'},
        {text: 'landingPageId', value: 'landingPageId'},
        {text: 'landingPageUrl', value: 'landingPageUrl'},
        {text: 'verticalName', value: 'verticalName'},
        {text: 'payOut', value: 'payOut'},
        {text: 'payIn', value: 'payIn'},
        {text: 'status', value: 'status'},
      ],
      offersItems: [],
    }
  }
}
</script>

<style scoped>

</style>
